import { BaseController, SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { AnimationBase, dispatcher, IEvent, ingenuity, Meter } from "@quest/base-core";
import { BonusSymTrailView } from "../BonusSymTrail/BonusSymTrailView";
import { BonusSymTrailController } from "../BonusSymTrail/BonusSymTrailController";
import { GameParserModel } from "../Platform/GameParserModel";

export class BaseControllerGame extends BaseController {
  private grandJackpotMeter: Meter;
  private majorJackpotMeter: Meter;
  private minorJackpotMeter: Meter;
  private miniJackpotMeter: Meter;
  private bonusSymTrailView: BonusSymTrailView;

  protected onInitializeAllControllers(evt: IEvent): void {
    super.onInitializeAllControllers(evt);
    this.initializeBonusTrailController();
  }

  /**
   * subscribeEvents method overrided for subscribe Jackpot Meters
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    this.unsubscribeEvents();
    dispatcher.on(eventDispatchers.UPDATE_TICKUP_WIN_METER, this.updateWinMeterWithTickup, this);
    dispatcher.on(eventDispatchers.HIDE_BASEGAME_REEL, this.hideReelView, this);
    dispatcher.on(eventDispatchers.SHOW_BASEGAME_REEL, this.showReelView, this);
    dispatcher.on(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES, this.updateJackpotMeterValues, this);
    dispatcher.on(eventDispatchers.PLAY_HOLD_AND_RESPIN_BLAST_ON_WIN_METER, this.playBlastAnimOnWinMeter, this);
  }

  protected unsubscribeEvents(): void {
    dispatcher.off(eventDispatchers.UPDATE_TICKUP_WIN_METER, this.updateWinMeterWithTickup, this);
    dispatcher.off(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES, this.updateJackpotMeterValues, this);
    dispatcher.off(eventDispatchers.HIDE_BASEGAME_REEL, this.hideReelView, this);
    dispatcher.off(eventDispatchers.SHOW_BASEGAME_REEL, this.showReelView, this);
  }

  protected initializeComponent(): void {
    super.initializeComponent();
    this.grandJackpotMeter = this.view.getMeterById("grandMeterText") as Meter;
    this.majorJackpotMeter = this.view.getMeterById("majorMeterText") as Meter;
    this.minorJackpotMeter = this.view.getMeterById("minorMeterText") as Meter;
    this.miniJackpotMeter = this.view.getMeterById("miniMeterText") as Meter;
  }

  /**
   * updateJackpotMeterValues method set Jackpot Meters Values
   */
  private updateJackpotMeterValues(): void {
    let currentBet: number = ingenuity.parserModel.getCurrentTotalBet();
    const grandJackpot = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotData().grand; //update multiplier values from server - dependancy
    const majorJackpot = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotData().major;
    const minorJackpot = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotData().minor;
    const miniJackpot = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotData().mini;
    this.grandJackpotMeter.setCurrencyFormattedValue(grandJackpot.toString() );
    this.majorJackpotMeter.setCurrencyFormattedValue(majorJackpot.toString());
    this.minorJackpotMeter.setCurrencyFormattedValue(minorJackpot.toString());
    this.miniJackpotMeter.setCurrencyFormattedValue(miniJackpot.toString());
  }

  //override to play button click sound on fast click
  protected onButtonRelesed(e: IEvent): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, { id: SoundConstant.CHANGE_BET_SOUND, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD });
    super.onButtonRelesed(e);
  }

  /**
   * play basegame sound after game intro
   */
  protected playBaseGameSoundsAfterGameIntro(): void {
    if (!(ingenuity.parserModel as GameParserModel).getFreeGameBroken()) {
      if (!(ingenuity.parserModel as GameParserModel).getIsFreeSpintriggered() && !SlotConstantsBehavior.FREEGAME_RETURN_SOUND) {
        if (!SlotConstantsBehavior.IS_PLAYED_BASE_GAMESOUND) {
          SlotConstantsBehavior.IS_PLAYED_BASE_GAMESOUND = true;
        }
        dispatcher.fireEvent(SlotEventConstantsBehavior.HANDLE_MULTIPLE_SOUND, {
          initialSound: { id: SoundConstant.BASEGAME_BGM_INTRO, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD },
          onCompletedSound: { id: SoundConstant.BASEGAME_BGMLOOP, vol: 1, loop: true, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD },
        });
      } else {
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
          id: SoundConstant.BASEGAME_BGMLOOP,
          vol: 1,
          loop: true,
          key: SlotConstantsBehavior.SOUND_LIST_PRELOAD,
        });
      }
      SlotConstantsBehavior.FREEGAME_RETURN_SOUND = false;
    }
  }

  /**
   * Override to update Jackpot Meters Values
   */
  protected onShowBaseGame(evt: IEvent): void {
    super.onShowBaseGame(evt);
    dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES);
  }

  /**
   * this function intialize the bonus symbol trail view
   */
  private initializeBonusTrailController(): void {
    this.bonusSymTrailView = new BonusSymTrailView(ingenuity.currentGame.cache.getJSON("main_data").bonusTrail);
    new BonusSymTrailController(this.bonusSymTrailView);
    ingenuity.currentGame.stage.addChild(this.bonusSymTrailView);
  }

  private hideReelView() {
    this.view.hide();
  }

  private showReelView() {
    this.view.show();
  }

  /**
   * play blast anim on console panel
   */
  private playBlastAnimOnWinMeter(): void {
    const lightAnim: AnimationBase = this.view.getAnimationById("lightHitAnimation");
    lightAnim.visible = true;
    lightAnim.playAnim(
      "anim",
      () => {
        lightAnim.visible = false;
      },
      this
    );
  }
  /**to show game logo  */
  protected showGameLogo(): void {
    if (ingenuity.deviceEnv.isDesktop) {
      super.showGameLogo();
    }
  }

  /**
   * to Update Win Value on win presentation is over
   */
  protected updateWinMeterWithTickup(evt: IEvent) {
    const duration = evt.data.duration;
    const winValue = evt.data.value;
    dispatcher.fireEvent(eventDispatchers.SET_WIN_VALUE, { winValue: winValue, creditValue: true, duration: duration });
  }
}
